<template>
  <div class="edit-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ isEdit ? '编辑安装公司' : '新增安装公司' }}</span>
        <el-button style="float: right;" type="text" @click="goBack">返回</el-button>
      </div>
      
      <el-form :model="form" :rules="rules" ref="companyForm" label-width="120px">
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入公司名称"></el-input>
        </el-form-item>

        <el-form-item label="公司简称" prop="short_name">
          <el-input v-model="form.short_name" placeholder="请输入公司简称"></el-input>
        </el-form-item>

        <el-form-item label="负责人" prop="owner">
          <el-input v-model="form.owner" placeholder="请输入负责人姓名"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="mobile">
          <el-input v-model="form.mobile" maxlength="11" placeholder="请输入联系电话"></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱地址"></el-input>
        </el-form-item>

        <el-form-item label="公司地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入公司详细地址"></el-input>
        </el-form-item>

        <el-form-item label="社会信用代码" prop="uscc">
          <el-input v-model="form.uscc" placeholder="请输入统一社会信用代码"></el-input>
        </el-form-item>

        <el-form-item label="营业执照" prop="file">
          <div>
            <el-button @click="fileClick">{{ dialogImageUrl ? '修改文件' : '选择文件' }}</el-button>
            <span style="margin-left: 20px; margin-right: 20px">{{ form.file ? form.file.name : form.usccFileName }}</span>
            <input
              style="display: none"
              type="file"
              name="file"
              @change="getFile($event)"
              ref="fileInput"
            />
            <el-button
              size="mini"
              round
              v-show="dialogImageUrl"
              @click="handlePictureCardPreview"
            >预览</el-button>
          </div>
        </el-form-item>

        <el-form-item style="margin-top: 30px;">
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="goBack">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-dialog :visible.sync="dialogVisible" width="90%">
      <template>
        <iframe
          :src="dialogImageUrl"
          style="width: 100%; height: 600px; border: none"
        ></iframe>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CompanyEdit',
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系电话'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    
    // 邮箱验证规则
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(value)) {
        callback(new Error('请输入正确的邮箱地址'));
      } else {
        callback();
      }
    };
    
    return {
      isEdit: false,
      dialogImageUrl: '',
      dialogVisible: false,
      form: {
        id: 0,
        name: '',
        short_name: '',
        owner: '',
        mobile: '',
        email: '',
        address: '',
        uscc: '',
        usccFileName: '',
        file: null
      },
      rules: {
        name: { required: true, message: '请输入公司名称', trigger: 'blur' },
        short_name: { required: true, message: '请输入公司简称', trigger: 'blur' },
        owner: { required: true, message: '请输入负责人', trigger: 'blur' },
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        address: { required: true, message: '请输入公司地址', trigger: 'blur' }
      }
    };
  },
  created() {
    const id = this.$route.query.id;
    if (id) {
      if (this.$store.state.editInfo.length == 0 || !this.$store.state.editInfo.id) {
        this.$router.push('/install/company/index');
      } else {
        this.isEdit = true;
        this.form = this.$store.state.editInfo;
        this.dialogImageUrl = this.$store.state.editInfo.usccFile || '';
      }
    }
  },
  methods: {
    // 点击选择文件
    fileClick() {
      this.$refs.fileInput.click();
    },
    
    // 获取文件
    getFile(event) {
      const files = event.target.files;
      if (files.length === 0) return;
      
      const file = files[0];
      const fileName = file.name;
      
      // 验证文件类型
      const validExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.pdf'];
      const isValid = validExtensions.some(ext => fileName.toLowerCase().includes(ext));
      
      if (isValid) {
        this.form.file = file;
        this.dialogImageUrl = URL.createObjectURL(file);
        this.form.usccFileName = fileName;
      } else {
        this.$message.error('文件类型仅为图片或PDF格式');
        this.$refs.fileInput.value = null;
      }
    },
    
    // 预览文件
    handlePictureCardPreview() {
      this.dialogVisible = true;
    },
    
    // 提交表单
    submitForm() {
      this.$refs.companyForm.validate((valid) => {
        if (valid) {
          const headers = {
            'Content-Type': 'multipart/form-data'
          };
          
          const formData = new FormData();
          
          // 添加所有表单字段到 FormData
          Object.keys(this.form).forEach((key) => {
            if (this.form[key] !== null && this.form[key] !== undefined && this.form[key] !== '') {
              formData.append(key, this.form[key]);
            }
          });
          
          // 根据是否是编辑模式选择不同的接口
          const url = this.form.id === 0 ? '/manage/institution/add' : '/manage/institution/edit';
          
          this.$http.post(url, formData, { headers })
            .then(res => {
              if (res.data.code === 0) {
                this.$message.success(this.isEdit ? '修改成功' : '创建成功');
                this.goBack();
              } else {
                this.$message.error(res.data.message || '操作失败');
              }
            })
            .catch(err => {
              this.$message.error('网络请求失败');
              console.error(err);
            });
        } else {
          this.$message.error('请检查表单填写');
          return false;
        }
      });
    },
    
    // 返回
    goBack() {
      this.$router.push('/install/company/index');
    }
  }
};
</script>

<style scoped>
.edit-container {
  padding: 20px;
}
.box-card {
  max-width: 100%;
  margin: 0 auto;
}
</style>
